import React, { useState } from "react";
import "./popularAdsPage.css";
import SEOTags from "../../utils/SEOTags";
import RoundedLinkButton from "../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import Layout from "../../components/layout/Layout";
import useCheckIfMobile from "../../customHooks/useCheckIfMobile";
import { ReadMoreButton } from "../../components/Buttons/ReadMoreButton/ReadMoreButton";
import PopularSpaces from "../Home/PopularSpaces/PopularSpaces";

const BreadcrumbListSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: { "@id": "https://www.vakansa.se/", name: "Hem" },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `https://www.vakansa.se/populara-lokaltyper`,
        name: "Populära Lokaltyper",
      },
    },
  ],
};

const PopularAdsPage = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const isMobile = useCheckIfMobile();

  const isSectionOne = expandedSections["section1"] || false;
  const isSectionTwo = expandedSections["section2"] || false;

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <>
      <SEOTags
        title={"Populära Lokaltyper   "}
        description={
          "På Vakansa hittar du den perfekta lokalen för dina behov, vare sig det är kontor, biograf, konferensrum eller idrottshall, i hela landet."
        }
        canonicalUrl={"/populara-lokaltyper"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={BreadcrumbListSchema}
      />

      <Layout>
        <main className="popular-ads-container">
          <div className="popular-ads-top">
            <h1>Populära Lokaltyper</h1>
            <h2>
              Hitta din nästa eventlokal, möteslokal eller kanske biograf på{" "}
              <a href="https://vakansa.se">Vakansa</a>
            </h2>
            <div className="popular-ads-copy-intro">
              <p>
                Det finns massvis med populära lokaltyper på{" "}
                <a href="https://vakansa.se">Vakansa.se</a> och vi förstår
                vikten av att hitta rätt lokal som uppfyller dina krav och
                behov. Oavsett om du letar efter ett{" "}
                <a href="/lediga-lokaler/stockholm/kontorshotell%2Fco-working/vasagatan-7/672de1caf793f5deafc7e30a">
                  kontor på Vasagatan
                </a>
                ,{" "}
                <a href="/lediga-lokaler/solna/biograf/westfield-mall-of-scandinavia-stjarntorget-2/651f0ec986b88800081b8207">
                  biograf på mall of scandinavia i Solna
                </a>
                ,{" "}
                <a href="/lediga-lokaler/goteborg/moteslokal/haga-ostergata/65e73151b2a7a2000879a450">
                  konferensrum i Göteborg
                </a>{" "}
                eller kanske en idrottshall i våra storstäder kan vi på Vakansa
                hjälpa dig.
              </p>
            </div>
            <div>
              <h3>Upptäck vårt breda utbud av outnyttjade lokaler:</h3>
              <p>
                Vakansa är Sveriges enda nischade plattform för
                andrahandslokaler, med helt unika lokaler som egentligen är
                tagna, men som vi öppnar upp för dig!
              </p>
              {isMobile && !isSectionOne ? (
                <ReadMoreButton
                  isExpanded={isSectionOne}
                  onToggle={() => toggleSection("section1")}
                />
              ) : (
                <>
                  <div className="read-more-text">
                    <p>
                      Vi har identifierat 15 olika populära lokaltyper som vi
                      synliggör och tillgängliggör via vår plattform. Allt för
                      att du ska kunna hitta exakt den lokal du söker efter och
                      inse vilka möjligheter som faktiskt finns av att hyra
                      lokaler i andrahand.
                    </p>
                    <ul>
                      <li>
                        <a href="/lediga-lokaler/allakommuner/kontorslokal-kontorshotell&co-working">
                          Kontor, kontorshotell och coworking:
                        </a>{" "}
                        Vi har alla möjliga kontorslösningar till allt från
                        startups till medelstora företag. Välj mellan privata
                        kontorsrum i kontorshotell, eget kontor eller flexibla
                        coworking ytor som erbjuder allt från möbler till teknik
                        och gemenskap.
                      </li>

                      <li>
                        <a href="/lediga-lokaler/allakommuner/möteslokal">
                          Möteslokaler:
                        </a>{" "}
                        På vår plattform finns allt från enkla mötesrum till
                        professionella konferenslokaler att hyra per timme eller
                        dag. Hör av dig direkt till hyresvärdarna via Vakansa
                        och ta reda på om de är utrustade med all nödvändig
                        teknologi för just era möten.
                      </li>

                      <li>
                        <a href="/lediga-lokaler/allakommuner/idrott&danslokal">
                          Idrottshallar, gymnastiksalar och danslokaler:
                        </a>{" "}
                        Vakansa är den enda plattformen idag som även har
                        lokaler inom idrott, dans och gymnastik. Anpassningsbara
                        lokaler för en mängd aktiviteter där du eller din
                        organisation kan ordna med allt från yoga, gympa till
                        streetdance.
                      </li>

                      <li>
                        <a href="/lediga-lokaler/allakommuner/eventlokal">
                          Eventlokaler:
                        </a>{" "}
                        Planera ditt nästa event som en julfest, halloween eller
                        sommarfest genom att besöka någon av de lokaler vi har
                        på vår plattform. Vi har flera eventlokaler som passar
                        perfekt för allt från företagsevent, konferenser till
                        privata festligheter.
                      </li>
                    </ul>
                    <p>
                      Varje outnyttjad lokal är en förlorad resurs. Pengar som
                      går till uppvärmd luft. Genom Vakansa kan du därför hitta
                      billiga alternativ, men också bidra till en mer hållbar
                      lokalanvändning genom att maximera lokalernas
                      nyttjandegrad och minska miljöpåverkan från onödigt
                      nybygge.
                    </p>
                    <p>
                      Vi har gjort det till vår mission att lokaler ska
                      användas, inte stå tomma i onödan!
                    </p>
                  </div>
                  {isMobile && (
                    <ReadMoreButton
                      isExpanded={isSectionOne}
                      onToggle={() => toggleSection("section1")}
                    />
                  )}
                </>
              )}
            </div>

            <div>
              <h3>Lokaler över hela Sverige</h3>
              <p>
                Använd sökord som "hyr coworking i Stockholm" eller "hyra
                danslokal i Malmö" för att snabbt hitta vad du letar efter. Vare
                sig du är en entreprenör, ett växande företag eller en kreativ
                själ som letar efter den perfekta arbetsplatsen eller
                dansstudion, är <a href="https://vakansa.se">Vakansa.se</a> här
                för att hjälpa dig hitta din idealiska lokal. Vi har:
              </p>
              {isMobile && !isSectionTwo ? (
                <ReadMoreButton
                  isExpanded={isSectionTwo}
                  onToggle={() => toggleSection("section2")}
                />
              ) : (
                <>
                  <div className="read-more-text">
                    <ul>
                      <li>
                        Lokaler i{" "}
                        <a href="/lediga-lokaler/stockholm">Stockholm</a>,{" "}
                        <a href="/lediga-lokaler/malmö">Malmö</a>,{" "}
                        <a href="/lediga-lokaler/uppsala">Uppsala</a>,{" "}
                        <a href="/lediga-lokaler/göteborg">Göteborg</a> och
                        andra städer.
                      </li>
                      <li>
                        Våra hyresvärdar erbjuder flexibla hyresavtal och
                        konkurrenskraftiga priser.
                      </li>
                      <li>
                        En användarvänlig plattform som gör det enkelt att söka
                        och jämföra olika lokaler.
                      </li>
                      <li>
                        Professionell support och personlig service för att
                        säkerställa en smidig uthyrningsprocess.
                      </li>
                    </ul>
                  </div>
                  {isMobile && (
                    <ReadMoreButton
                      isExpanded={isSectionTwo}
                      onToggle={() => toggleSection("section2")}
                    />
                  )}
                </>
              )}
            </div>
            <div>
              <h3>Hyr ut lokal via Vakansa så kan den också bli populär!</h3>
              <p>
                Många fastighetsägare och förstahandshyresgäster där ute har
                lokaler som står helt eller delvis tomma. Ytor som bara väntar
                på att aktiveras med rätt hyresgäster och verksamheter. Sitter
                du på en lokal som står oanvänd eller dåligt nyttjad? Hyr ut
                lokal enkelt och flexibelt med Vakansa. Vi erbjuder en mångsidig
                plattform där du kan anpassa din uthyrning efter dina önskemål,
                oavsett om du föredrar korttids- eller långtidsuthyrning.
              </p>
              <br />
              <p>
                Hyr ut den genom att registrera ett konto och skapa en annons
                via Vakansa.
              </p>
              <RoundedLinkButton
                label={"Hyr ut lokal"}
                color={"green"}
                size={"md"}
                href={"/hyr-ut-lokal"}
              />
            </div>
            <div className="faq-section">
              <div>
                <h3>Vanliga frågor och svar</h3>
                <p>
                  Söker du svar på några specifika frågor kring hur det är att
                  vara hyresvärd eller hyresgäst via Vakansa?
                </p>
                <br />
                <p>
                  Vi har samlat alla möjliga svar på de vanligaste frågorna som
                  vi fått från våra användare genom åren och som du kan hitta
                  genom att klicka nedan.
                </p>
                <RoundedLinkButton
                  label={"Frågor & svar"}
                  color={"green"}
                  size={"md"}
                  href={"/fragor-och-svar"}
                />
              </div>
              <div>
                <p>
                  Följ vår utveckling och läs det senaste om oss i vår nya
                  blogg! Här kan du hitta information om branschen i stort, om
                  hur det ser ut på lokalmarknaden och hur hållbarhetsfrågorna
                  tangerar det vi gör.
                </p>
                <br />
                <p>
                  Det brukar sägas att bygg- och fastighetsbranschen är
                  samhällets motor och då är det viktigt att hålla koll på vad
                  som sker i branschen. Annars är risken att vi inte bygger en
                  stad för människor och verksamheter, utan människor och
                  verksamheter som anpassar sig för staden.
                </p>
                <RoundedLinkButton
                  label={"Gå till bloggen"}
                  color={"green"}
                  size={"md"}
                  href={"/blogg"}
                />
              </div>
            </div>
          </div>
          <PopularSpaces />
        </main>
      </Layout>
    </>
  );
};

export default PopularAdsPage;
